// import map from "../assets/map.svg"

import { Link } from "react-router-dom"
import AlumniMap from "../components/ourAlumni/alumniMap"

const OurAlumni = () => {
    
    return (
        <div className="relative bg-white  text-black w-full p-6 flex flex-col items-center justify-center overflow-x-hidden">

            <div className="max-w-4xl w-full h-full p-3 flex flex-col  items-center  gap-8 ">
                <div className="w-full flex flex-col items-center gap-6">
                    <h1 className="text-4xl font-bold">Our Alumni</h1>
                    <p className="text-xs 2xl:text-[16px] 2xl:leading-7 text-center text-gray-500">Our graduates are now making their mark in over 70 countries around the globe.</p>
                    <Link to={"/alumni-relations-career"} className='p-2 px-3  border w-fit rounded-sm font-bold my-2 text-xs 2xl:text-sm text-[#0039cb] border-[#0039cb] flex items-center gap-1'>View All</Link>
                
                </div>
            </div>
            <AlumniMap/>
        </div>
    )
}

export default OurAlumni